import { render } from "./MemberAvatar.vue?vue&type=template&id=78423e0e&scoped=true"
import script from "./MemberAvatar.vue?vue&type=script&lang=js"
export * from "./MemberAvatar.vue?vue&type=script&lang=js"

import "./MemberAvatar.vue?vue&type=style&index=0&id=78423e0e&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-78423e0e"]])

export default __exports__